import { render } from "./AlertValidade.vue?vue&type=template&id=7a39dfa7&scoped=true"
import script from "./AlertValidade.vue?vue&type=script&lang=js"
export * from "./AlertValidade.vue?vue&type=script&lang=js"

import "./AlertValidade.vue?vue&type=style&index=0&id=7a39dfa7&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src130918171/src/app-heineken/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a39dfa7"]])

export default __exports__